import { getLiveTagValue } from "@/features/datapoints/api/getLiveTagValue.ts"

import type { FlowRateDisplayData } from "../../types/flowRateDisplayTypes.ts"

export const getFlowRateDisplayData = async (): Promise<FlowRateDisplayData> => {
  const values = await Promise.all([
    getLiveTagValue("default/BCO/Live/800/Inlet Flow Rate (SCFM)"),
    getLiveTagValue("default/BCO/Live/800/Inlet Methane Content (CH4 pct)"),
    getLiveTagValue("default/BCO/Live/850/Oneok Pipeline Meter/Gas to Pipeline Flow (MSCFD)"),
    getLiveTagValue(
      "default/BCO/Live/850/Oneok Pipeline Meter/Gas to Pipeline Methane Content (CH4 pct)",
    ),
    getLiveTagValue("default/BCO/Live/Plant Status"),
  ])

  return {
    inletSCFM: values[0],
    inletCH4: values[1],
    outletSCFM: values[2] / 1.44, // Converting MSCFD to SCFM
    outletCH4: values[3],
    online: values[4] == 0 ? false : true,
  }
}
